import $ from 'jquery';

const lpInit = lp => {

    // Check if the page is an article
    if($('.articleBody').length) {
        // Check if referrer exists and the url includes the hostname
        if (document.referrer !== '' && document.referrer.includes(window.location.host)) {
            lp.attr('href', document.referrer);
        } else {
            lp.html('Artikler');
            lp.attr('href', '/artikler');
        }
    }

};

// Check if element exists and execute the code
if ($('#lastPageRef').length) {
    lpInit($('#lastPageRef'));
}